import moment from 'moment';
import { find, each } from 'lodash';
import { AGENT_STATUSES, DATA_LOADING_STATES, METRIC_NAMES } from '@config/Consts';
import { AGENT_LIST_RESOURCES } from './Consts';

const agentMetricsTemplate = () => {
  const agentTemplate = {
    id: null,
    metrics: [
      { metric: METRIC_NAMES.AGENT_VIEW_AGENT_NOTIFICATIONS,
        score: 0,
        reasons: [],
      },
      { metric: METRIC_NAMES.AGENT_VIEW_AGENT_PICTURE,
        score: null,
      },
      { metric: METRIC_NAMES.AGENT_VIEW_AGENT_LOAD,
        score: null,
      },
      { metric: METRIC_NAMES.AGENT_VIEW_AGENT_STATUS,
        score: AGENT_STATUSES.OFFLINE,
      },
      { metric: METRIC_NAMES.AGENT_VIEW_AGENT_STATUS_WITH_REASON_DURATION,
        score: null,
      },
      { metric: METRIC_NAMES.AGENT_VIEW_STATUS_REASON,
        score: null,
      },
      { metric: METRIC_NAMES.AGENT_VIEW_ASSIGNED_CONVERSATIONS,
        score: null,
      },
      { metric: METRIC_NAMES.AGENT_VIEW_CSAT,
        score: null,
      },
      { metric: METRIC_NAMES.AGENT_VIEW_CLOSED_CONVERSATIONS,
        score: null,
      },
      { metric: METRIC_NAMES.ONLINE_RATE, // agents activity API
        score: null,
      },
      { metric: METRIC_NAMES.AGENT_VIEW_AGENT_NAME,
        score: null,
      },
      { metric: METRIC_NAMES.AGENT_VIEW_AGENT_GROUP,
        score: null,
      },
      { metric: METRIC_NAMES.AGENT_VIEW_AGENT_SKILLS,
        score: null,
      },
      { metric: METRIC_NAMES.AGENT_VIEW_ACTIVE_CONVERSATIONS,
        score: null,
      },
      { metric: METRIC_NAMES.AGENT_VIEW_MAX_SLOTS,
        score: null,
      },
      {
        metric: METRIC_NAMES.AGENT_VIEW_TRANSFER_RATE,
        score: null,
      },
    ],
  };
  return agentTemplate;
};

const setAgentsMetrics = (state, agentsMetrics) => {
  const handleMetric = (metric, metrics) => {
    const metricData = find(metrics, m => m.metric === metric.metric);
    if (metricData) {
      metricData.score = metric.score;
    }
  };
  state.agentsMetrics = [];
  each(agentsMetrics, (agentMetrics) => {
    const agent = agentMetricsTemplate();
    agent.id = agentMetrics.id;
    each(agentMetrics.metrics, metric => handleMetric(metric, agent.metrics));
    state.agentsMetrics.push(agent);
  });
};

const setDataStatus = (state, value) => {
  state.dataStatus[value.resourceName] = value.status;
};

const updateAgentsMetrics = (state, data) => {
  setDataStatus(state, { resourceName: data.resourceName, status: data.dataStatus });
  if (data.dataStatus === DATA_LOADING_STATES.SUCCESS) {
    state.lastTimeDataUpdated[data.resourceName] = moment();
    setAgentsMetrics(state, data.agentsMetrics);
  }
};

const setWidgetMode = (state, value) => {
  state.widgetMode = value;
};

const setStatusFilter = (state, selectedStatuses) => {
  state.filter.status = selectedStatuses;
};

const setAgentsFilter = (state, selectedAgents) => {
  state.filter.agents = selectedAgents;
};

const setAgentStatusSummary = (state, data) => {
  setDataStatus(state, {
    resourceName: AGENT_LIST_RESOURCES.METRICS,
    status: data.dataStatus,
  });
  if (data.dataStatus === DATA_LOADING_STATES.SUCCESS) {
    state.lastTimeDataUpdated[AGENT_LIST_RESOURCES.METRICS] = moment();
    Object.keys(AGENT_STATUSES).forEach((status) => {
      state.agentStatusSummary[AGENT_STATUSES[status]] =
        data.statusSummary[AGENT_STATUSES[status]];
    });
  }
};

const setSort = (state, sort) => {
  state.sort = sort;
};

const setPresetValues = (state, preset) => {
  setWidgetMode(state, preset.widgetMode);
  setStatusFilter(state, preset.statusFilter);
  setAgentsFilter(state, preset.agentsFilter);
  setSort(state, preset.sort);
};

export default {
  agentMetricsTemplate,
  setAgentsMetrics,
  updateAgentsMetrics,
  setDataStatus,
  setWidgetMode,
  setStatusFilter,
  setAgentsFilter,
  setAgentStatusSummary,
  setSort,
  setPresetValues,
};
